import { Button, Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";

export default function ModalFormCp({
  show,
  onHide,
  editCpId,
  formCp,
  handleChangeFormCp,
  handleSubmitCp,
  isSubmittingCp,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="modal-cp"
      centered
      backdrop="static"
      keyboard={false}
    >
      <div className="d-flex header-modal">
        <h5>{editCpId ? "Update CP" : "Buat CP"}</h5>

        <div className="ml-auto x-close">
          <FontAwesomeIcon icon={faTimes} onClick={onHide} />
        </div>
      </div>

      <hr />

      <Modal.Body className="modal-body">
        <Form onSubmit={handleSubmitCp}>
          <div className="mt-3 label-group-form">
            <label className="label-name-form">Nama CP</label>
            <input
              className="label-input-form"
              autoFocus
              type="text"
              name="nama_cp"
              placeholder="Masukkan nama CP"
              value={formCp.nama_cp}
              onChange={handleChangeFormCp}
              disabled={isSubmittingCp}
            />
          </div>

          <div className="mt-4 label-group-form">
            <label className="label-name-form">Topik</label>
            <input
              className="label-input-form"
              type="text"
              name="topik"
              placeholder="Masukkan topik"
              value={formCp.topik}
              onChange={handleChangeFormCp}
              disabled={isSubmittingCp}
            />
          </div>

          <div className="mt-4 label-group-form">
            <label className="label-name-form">Keterangan</label>
            <input
              className="label-input-form"
              type="text"
              name="keterangan"
              placeholder="Masukkan keterangan"
              value={formCp.keterangan}
              onChange={handleChangeFormCp}
              disabled={isSubmittingCp}
            />
          </div>

          <div
            className="d-flex mt-4"
            style={{
              justifyContent: "flex-end",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <Button
              type="button"
              className="btn btn-light"
              onClick={onHide}
              disabled={isSubmittingCp}
              style={{
                borderRadius: 10,
                fontWeight: 600,
                padding: "8px 14px",
              }}
            >
              Batal
            </Button>

            <Button
              className="btn-modal-create"
              type="submit"
              disabled={isSubmittingCp}
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                fontWeight: 600,
              }}
            >
              {isSubmittingCp ? (
                <PulseLoader color="#fff" size={8} />
              ) : (
                <>
                  <FontAwesomeIcon icon={editCpId ? faSave : faPlus} />{" "}
                  {editCpId ? "Perbarui" : "Tambahkan"}
                </>
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}